/**
 * How opaque each time layer draws, 0.1-1, set from the time bar's slider and remembered
 * per layer in this browser. The 2D tiles and the 3D raster read it; a layer never set
 * draws as it always has (1 in 2D, 3D's own 0.85).
 *
 * Kept outside Redux like the frame store: dragging the slider restyles tiles directly.
 */
const KEY = 'timeLayerOpacity'
export const MIN_OPACITY = 0.1

const read = () => {
  try {
    const saved = JSON.parse(window.localStorage.getItem(KEY) || '{}')
    return new Map(Object.entries(saved).map(([id, v]) => [Number(id), v]))
  } catch (e) {
    return new Map()
  }
}

const opacities = read()   // layerId -> 0.1..1
const listeners = new Set()

export const clampOpacity = v => Math.max(MIN_OPACITY, Math.min(1, Number(v) || 0))

/** The layer's opacity, 1 when it was never set. */
export function opacityFor(layerId) {
  return opacities.has(layerId) ? opacities.get(layerId) : 1
}

export function setLayerOpacity(layerId, value) {
  const v = clampOpacity(value)
  if (opacityFor(layerId) === v) return
  opacities.set(layerId, v)
  try {
    window.localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(opacities)))
  } catch (e) {
    // Private windows and blocked storage: the slider still works for this visit.
  }
  listeners.forEach(fn => fn(layerId, v))
}

/** `fn(layerId, opacity)` on every change; returns the unsubscribe. */
export function subscribeOpacity(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
